import React from 'react';
import { Navigate } from 'react-router-dom';
import adminAuthService from '../services/adminAuthService';

const ProtectedAdminRoute = ({ children }) => {
  const user = adminAuthService.getAdminUser();
  if (!user || !['PLATFORM_OWNER', 'PLATFORM_ADMIN'].includes(user.platformRole)) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

export default ProtectedAdminRoute;
